import { useAppDispatch } from "hooks/reduxHook";
import { useEffect, useRef } from "react";
import { mqttService } from "services";
import { RealtimeClient } from "services/mqtt/mqtt.service";
import { setMqttClient } from "store/ducks/mqtt/slice";

const useMqtt = () => {
	const dispatch = useAppDispatch();
	const _mqttListener = useRef<RealtimeClient | undefined>();

	useEffect(() => {
		const handleError = (error: Error) => {
			const payload = {
				client: null,
				error,
			};
			dispatch(setMqttClient(payload));
		};

		(async () => {
			const url = mqttService.getGatewayUrl();

			try {
				const client = await mqttService.getClient(url, undefined, handleError);
				if (!client || !client?.connected) return;
				const payload = {
					client: client,
					error: null,
				};

				_mqttListener.current = payload.client;
				dispatch(setMqttClient(payload));
			} catch (err: any) {
				handleError(err);
			}
		})();
	}, [dispatch]);

	/** end connection when un-mount */
	useEffect(() => {
		return () => {
			if (_mqttListener.current) {
				const payload = {
					client: null,
					error: null,
				};
				dispatch(setMqttClient(payload));
				mqttService.closeConnection(_mqttListener.current);
			}
		};
	}, [dispatch]);

	return null;
};

export default useMqtt;
